export const avisos_privacidad_item = [
    {
        "avisos_privacidad_item_titulo" : "Tribunal de Arbitraje",
        "avisos_privacidad_item_nombre" : "Aviso de privacidad",
        "avisos_privacidad_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/avisos/AVISO_PRIVACIDAD_TAEH.pdf"
    },{
        "avisos_privacidad_item_titulo" : "Procuraduria de la Defensa del Trabajo",
        "avisos_privacidad_item_nombre" : "Aviso de privacidad",
        "avisos_privacidad_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/avisos/AVISO_PRIVACIDAD_PEDT.pdf"
    },{
        "avisos_privacidad_item_titulo" : "Dirección de Normatividad Laboral",
        "avisos_privacidad_item_nombre" : "Aviso de privacidad",
        "avisos_privacidad_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/avisos/AVISO_PRIVACIDAD_DNL.pdf"
    },{
        "avisos_privacidad_item_titulo" : "Dirección de Procedimientos Administrativos",
        "avisos_privacidad_item_nombre" : "Aviso de privacidad",
        "avisos_privacidad_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/avisos/AVISO_PRIVACIDAD_PAS.pdf"
    },{
        "avisos_privacidad_item_titulo" : "Dirección General del Trabajo y Previsión Social",
        "avisos_privacidad_item_nombre" : "Aviso de privacidad",
        "avisos_privacidad_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/avisos/AVISO_PRIVACIDAD_DGTPS.pdf"
    }
]